<template>
    <iframe
        class="main-iframe"
        :src="src"
        id="show-iframe"
        ref="webView"
        allowfullscreen
        webkitallowfullscreen
        mozallowfullscreen
    ></iframe>
</template>

<script>
import { getUserInfoByDomainName } from "../utils/api-utils/request-utils";
// 用户域名配置
const userDomianMap = {
    "sanbox.jackyun.com": "NjY5OTE=", // 66991 - 内测绑定测试
    "www.liwucam.com": "MjExODg4MTg=", // 21188818（运维隐性URL - https://jmallpc.jackyun.com）
    "liwucam.com": "MjExODg4MTg=", // 21188818
    //"www.isd365.com": "OTkwNDEx", // 990411（用户隐性URL - https://jmall.jackyun.com/jmc/pcmall/?OTkwNDEx#/home）
    //"isd365.com": "OTkwNDEx", // 990411
    "www.haoshun365.com": "ODg5OTMz", // 889933（用户隐性URL - https://jmallpc.jackyun.com）
    "www.yueqinghaidie.com": "Nzk1MzMw", // 795330（用户隐性URL - https://jmall.jackyun.com/jmc/pcmall/?Nzk1MzMw#/home）
    "yueqinghaidie.com": "Nzk1MzMw", // 795330
    "mall.guoding333.com": "MTg2MDY4", // 186068（已停用，运维隐性URL）
    "www.yingxingweiye.com.cn": "Njg2OTY4", // 686968（已停用，运维隐性URL）
    "jmall2.jackyun.com": "NjY5OTE", // 66991
    "aiben.cn": "NjYwMjk5", // 660299（运维隐性URL）
    "www.aiben.cn": "NjYwMjk5", // 660299
    "www.11034.com": "MTA4MDAx", // 108001（用户重定向 - 直接转到https://jmall.jackyun.com/jmc/pcmall/?MTA4MDAx#/home）
    "11034.com": "MTA4MDAx", // 108001
    "www.yuecaikj.com": "MTgwNjE2", // 180616
    "yuecaikj.com": "MTgwNjE2", // 180616（用户隐性URL - https://jmall.jackyun.com/jmc/pcmall/?NjExNDI0#/home）
    "www.pipeydc.com": "OTMxNjg4", // 931688
    "pipeydc.com": "OTMxNjg4", // 931688（运维隐性URL）
    "www.jcfor.com": "ODgxOTY4", // 881968（运维隐性URL）
    "jcfor.com": "ODgxOTY4", // 881968
    "eyeslive.net": "NjU1Mzc4", // 655378（用户隐性URL - https://jmallpc.jackyun.com）
    "xanadn.com": "NTA2NDg5", // 506489（运维隐性URL - https://jmallpc.jackyun.com）
    "www.xanadn.com": "NTA2NDg5", // 506489（运维隐性URL - https://jmallpc.jackyun.com）
    "www.haiyuan.shop": "NjQ2Mzg4", // 646388（用户隐性URL - https://jmallpc.jackyun.com）- 不用了
    "haiyuan.shop": "NjQ2Mzg4", // 646388（用户隐性URL - https://jmallpc.jackyun.com）- 不用了
    "haiyuanvip.com": "NjQ2Mzg4", // 646388（用户隐性URL - https://jmallpc.jackyun.com）
    "www.haiyuanvip.com": "NjQ2Mzg4", // 646388（用户隐性URL - https://jmallpc.jackyun.com）
    "www.jdy99.com": "ODI1OTc5", // 825979（用户隐性URL - https://jmallpc.jackyun.com）
    "jdy99.com": "ODI1OTc5", // 825979（用户隐性URL - https://jmallpc.jackyun.com）
    "www.shenquanriyong.cn": "ODgyMzgy", // 882382（用户隐性URL - https://jmallpc.jackyun.com）
    "shenquanriyong.cn": "ODgyMzgy", // 882382（用户隐性URL - https://jmallpc.jackyun.com）
    "91jsjc.com": "MTgwNjE2X25ieWMxMzY2", // 180616_nbyc1366（用户隐性URL - https://jmallpc.jackyun.com）
    "www.91jsjc.com": "MTgwNjE2X25ieWMxMzY2", // 180616_nbyc1366（用户隐性URL - https://jmallpc.jackyun.com）
    "whelala.com": "MzE5NzEw", // 319710（用户隐性URL - https://jmallpc.jackyun.com）
    "www.whelala.com": "MzE5NzEw", // 319710（用户隐性URL - https://jmallpc.jackyun.com）
    "zlhcgroup.com": "NjYxMDA2", // 661006（用户隐性URL - https://jmallpc.jackyun.com）
    "www.daxingyuyi.com": "MTIwNTk4", // 120598（用户隐性URL - https://jmallpc.jackyun.com）
    "shinetrip.net": "NzU2NTk2", // 756596（用户隐性URL - https://jmallpc.jackyun.com）
    "www.shinetrip.net": "NzU2NTk2", // 756596（用户隐性URL - https://jmallpc.jackyun.com）
    "bptkj.com": "NTE4Nzc4", // 518778（用户隐性URL - https://jmallpc.jackyun.com）
    "www.bptkj.com": "NTE4Nzc4", // 518778（用户隐性URL - https://jmallpc.jackyun.com）
    "ehottop.cn": "MzM2NjA2", // 336606 - https://jmallpc.jackyun.com）
    "www.ehottop.cn": "MzM2NjA2", // 336606（用户隐性URL - https://jmallpc.jackyun.com）
};

export default {
    data() {
        return {
            src: "",
        };
    },
    mounted() {
        // 特殊的URL重定向
        this._rethinkUrl();

        // 执行中转
        this._doTransfer();

        // qq浏览器重新渲染
        // this._iframeShowForQQ();

        // this.loadIframe();
        window.addEventListener("message", this.handleMessage);
    },
    computed: {
        /**
         * 获取当前域名
         */
        domianName() {
            // 优先检测起源域名
            let originDomian = window.location.ancestorOrigins[0];
            if (originDomian) {
                return originDomian
                    .replace("http://", "")
                    .replace("https://", "");
            }
            // 再检测直接绑定的域名
            return window.location.host;
        },

        /**
         * 获取当前域名
         */
        originsHref() {
            // 优先检测起源域名
            let originDomian = window.location.ancestorOrigins[0];
            if (originDomian) {
                return originDomian;
            }
            // 再检测直接绑定的域名
            return window.location.origin;
        },
    },
    created() {},
    methods: {
        /**
         * 特殊的URL重定向
         */
        _rethinkUrl() {
            console.log("domianName：", this.domianName);
            console.log("originsHref：", this.originsHref);
            if (
                this.domianName == "haiyuanvip.com" ||
                this.originsHref == "http://www.haiyuanvip.com"
            ) {
                window.location.href = "https://www.haiyuanvip.com";
            }
        },

        /**
         * 执行跳转
         */
        async _doTransfer() {
            // 获取传参
            let params = this.__getUrlParams();
            console.log("1. params:", params);

            // 通过接口获取吉克号信息
            let domianNameOfReq = await this.__getUserInfoByDomainName(
                this.domianName,
            );
            console.log("2. domianNameOfReq:", domianNameOfReq);
            console.log("3. userDomianMap[this.domianName]:", userDomianMap[this.domianName]);

            // 加密吉客号
            let memberName = domianNameOfReq || userDomianMap[this.domianName];
            console.log("4. memberName:", memberName);

            // 基础地址
            let baseUrl = `https://jmall.jackyun.com/jmc/pcmall/?${memberName}#/`;
            console.log("5. baseUrl:", baseUrl);

            // 根据目标执行不同的跳转
            let targetPage;
            switch (params.t) {
                // 商品详情
                case "gd":
                    targetPage = `goodsdetail?id=${params.gid}`;
                    break;
                // 抢购详情
                case "tgd":
                    targetPage = `timedsalegoodsdetail?goodsId=${
                        params.gid
                    }&saleId=${params.aid}`;
                    break;
                // 默认跳转到首页
                default:
                    targetPage = "home";
                    break;
            }
            console.log("6. targetPage:", targetPage);

            // 传递当前域名
            let finalUrl;
            if (targetPage.includes("?")) {
                finalUrl = `${baseUrl}${targetPage}&ref=${this.originsHref}`;
            } else {
                finalUrl = `${baseUrl}${targetPage}?ref=${this.originsHref}`;
            }
            console.log("7. 最终跳转地址:", finalUrl);

            // 赋值中转连接
            this.src = finalUrl;
        },

        /**
         * 获取地址栏传参
         */
        __getUrlParams() {
            try {
                let searchParams = new URLSearchParams(window.location.search);
                let params = {};
                for (let [key, value] of searchParams.entries()) {
                    params[key] = value;
                }
                return params;
            } catch (e) {
                return {};
            }
        },

        //*********以下方法写的很乱，暂时废弃**********

        /**
         * qq浏览器重新渲染
         */
        _iframeShowForQQ() {
            let id = document.getElementById("show-iframe");
            id.addEventListener("load", function() {
                id.style.visibility = "hidden";
                requestAnimationFrame(function() {
                    id.style.visibility = "visible";
                });
            });
        },

        loadIframe() {
            // 获取url的hash值
            let iframehash = window.location.hash;
            let index = iframehash.lastIndexOf("\/") + 1;
            let subInfo = iframehash.substring(index);
            console.log(this.domianName);
            if (this.domianName == "haiyuanvip.com") {
                window.location.href = "https://www.haiyuanvip.com";
            }

            this.src =
                "https://jmall.jackyun.com/jmc/pcmall/?" +
                userDomianMap[this.domianName] +
                "#/";

            if (!!subInfo && subInfo != "/") {
                this.src = this.src + subInfo;
            } else {
                this.src = this.src + "home";
            }
        },

        handleMessage(event) {
            let that = this;
            let data = event.data;
            if (!!data && data.type === "favicon") {
                that.setFavicon(data.url);
                document.title = data.mallName;
            }
        },

        setFavicon(url) {
            // 设置外层页面的 favicon
            let link = document.getElementById("outFavicon");
            if (!link) {
                link = document.createElement("link");
                link.rel = "icon";
                document.head.appendChild(link);
            }
            link.href = url;
        },

        /**
         * name
         * @param {}
         */
        async __getUserInfoByDomainName(domianName) {
            let userInfo = await getUserInfoByDomainName(domianName);
            return window.btoa(
                window.encodeURIComponent(
                    `${userInfo.memberName || ""}${
                        userInfo.accountName ? "_" + userInfo.accountName : ""
                    }` || "",
                ),
            );
        },
    },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.main-iframe {
    width: 100% !important;
    height: 100% !important;
    border: 0 !important;
}
</style>
